<div class="row pt-3 settings-row">
  <div class="col-lg-6 col-md-8 col-sm-10 col-12 settings-col mb-5">

    <div class="form-group">
      <label for="nameInput">Document Name</label>
      <input id="nameInput" type="text" class="form-control"
             [(ngModel)]="documentTemplate.name"
             (ngModelChange)="unsavedChanges.emit()">
      <div class="form-text text-danger">{{ documentTemplateErrors.name }}</div>
    </div>

    <div class="form-group">
      <label for="documentTypeSelect">Document Type</label>
      <select id="documentTypeSelect" class="custom-select"
              [disabled]="documentTemplate.id !== null"
              [(ngModel)]="documentTemplate.document_type"
              (ngModelChange)="unsavedChanges.emit()">
        <option value="{{ DocumentType.waiver }}">Waiver/AoR</option>
        <option value="{{ DocumentType.supervisorForm }}">Supervisor Form</option>
        <option value="{{ DocumentType.proficiency }}">Proficiency</option>
        <option value="{{ DocumentType.membership_agreement }}">Membership Agreement</option>
        <option value="{{ DocumentType.custom }}">Custom</option>
      </select>
      <div class="form-text text-danger">{{ documentTemplateErrors.document_type }}</div>
    </div>

    <div class="form-group">
      <label for="isLocationRestrictedSelect">
        Is this document restricted to a certain location or set of locations?
      </label>
      <select id="isLocationRestrictedSelect" name="is_location_restricted"
              class="custom-select"
              [(ngModel)]="documentTemplate.is_location_restricted"
              (ngModelChange)="unsavedChanges.emit()">
        <option [ngValue]="true">Yes</option>
        <option [ngValue]="false">No</option>
      </select>
      <small class="form-text text-muted">
        If this option is enabled, the document will only be available in the kiosk mode of the chosen set of locations. In addition, if the document is a Waiver/AoR, it will only be usable for entry at the chosen set of locations.
      </small>
      <div class="form-text text-danger">{{ documentTemplateErrors.is_location_restricted }}</div>
    </div>

    <div class="form-group indented-subsection" *ngIf="documentTemplate.is_location_restricted">
          <label>
            Allowed Locations
          </label>
          <ul class="mb-2 pl-3">
            <li *ngFor="let location of documentTemplate.allowed_locations; let idx = index;">
              {{ location.name }}
              <a href="#" class="link-danger pl-1"
                 (click)="documentTemplate.allowed_locations.splice(idx, 1); unsavedChanges.emit(); $event.preventDefault();">
                Remove
              </a>
            </li>
            <li *ngIf="documentTemplate.allowed_locations.length === 0"
                class="text-muted">
              No locations selected
            </li>
          </ul>
          <a href="#"
             (click)="openAddAllowedLocationModal(); $event.preventDefault();">
            Select Location
          </a>
          <div class="form-text text-danger">{{ documentTemplateErrors.allowed_locations }}</div>
    </div>

    <div class="form-group">
      <label for="isAvailableInKioskModeSelect">Is this document visible in kiosk mode?</label>
      <select id="isAvailableInKioskModeSelect" class="custom-select"
              [(ngModel)]="documentTemplate.is_available_in_kiosk_mode"
              (ngModelChange)="unsavedChanges.emit()">
        <option [ngValue]="true">Yes</option>
        <option [ngValue]="false">No</option>
      </select>
      <div class="form-text text-danger">{{ documentTemplateErrors.is_available_in_kiosk_mode }}</div>
    </div>

    <div class="form-group">
      <label for="isAvailableInClimberAppSelect">Is this document visible in the Climber App?</label>
      <select id="isAvailableInClimberAppSelect" class="custom-select"
              [(ngModel)]="documentTemplate.is_available_in_climber_app"
              (ngModelChange)="unsavedChanges.emit()">
        <option [ngValue]="true">Yes</option>
        <option [ngValue]="false">No</option>
      </select>
      <div class="form-text text-danger">{{ documentTemplateErrors.is_available_in_climber_app }}</div>
    </div>

    <div class="form-group">
      <label for="requiresStaffApprovalSelect">Does this document require staff approval?</label>
      <select id="requiresStaffApprovalSelect" class="custom-select"
              [(ngModel)]="documentTemplate.requires_staff_approval"
              (ngModelChange)="unsavedChanges.emit()">
        <option [ngValue]="true">Yes</option>
        <option [ngValue]="false">No</option>
      </select>
      <div class="form-text text-danger">{{ documentTemplateErrors.requires_staff_approval }}</div>
      <small class="form-text text-muted">
        If this is set to "Yes", documents of this type will be added to the inbox when first completed. A document of this type will not be usable for entry, and its proficiencies will not be granted, until the document is approved by a staff member.
      </small>
    </div>

    <div class="form-group indented-subsection">
      <label for="order_number">Order Number</label>
      <div class="row">
        <div class="col-lg-6 col-md-8">
          <input id="order_number"
                 name="order_number"
                 class="form-control"
                 type="number"
                 step="1"
                 [(ngModel)]="documentTemplate.order_number"
                 (ngModelChange)="unsavedChanges.emit()">
        </div>
      </div>
      <small class="form-text text-muted">
        This determines the order that document templates are displayed in the Climber App. Lower numbers are displayed first. If two document templates have the same order number, they will be displayed in alphabetical order.
      </small>
      <div class="form-text text-danger">{{ documentTemplateErrors.order_number }}</div>
    </div>

    <div class="form-group">
      <label class="mb-0">After how long does this document expire?</label>
      <div class="row">
        <div class="col-6">
          <label for="yearsToExpirationInput" class="text-small mb-1">Years</label>
          <input type="number" class="form-control" id="yearsToExpirationInput"
                 min="0" step="1"
                 [(ngModel)]="documentTemplate.years_to_expiration"
                 (ngModelChange)="unsavedChanges.emit()">
          <div class="form-text text-danger">{{ documentTemplateErrors.years_to_expiration }}</div>
        </div>
        <div class="col-6">
          <label for="daysToExpirationInput" class="text-small mb-1">Days</label>
          <input type="number" class="form-control" id="daysToExpirationInput"
                 min="0" step="1"
                 [(ngModel)]="documentTemplate.days_to_expiration"
                 (ngModelChange)="unsavedChanges.emit()">
          <div class="form-text text-danger">{{ documentTemplateErrors.days_to_expiration }}</div>
        </div>
      </div>
      <small class="form-text text-muted">
        If both Years and Days are provided, they will be added to determine the time to expiration. In order to configure the document to never expire, leave both blank.
      </small>
    </div>

    <div class="form-group">
      <label for="expireWhenMinorBecomesAdultSelect">Does this document expire when a minor becomes an adult?</label>
      <select id="expireWhenMinorBecomesAdultSelect" class="custom-select"
              [(ngModel)]="documentTemplate.expire_when_minor_becomes_adult"
              (ngModelChange)="unsavedChanges.emit()">
        <option [ngValue]="true">Yes</option>
        <option [ngValue]="false">No</option>
      </select>
      <div class="form-text text-danger">{{ documentTemplateErrors.expire_when_minor_becomes_adult }}</div>
    </div>

    <div class="form-group" *ngIf="documentExpires()">
      <div class="custom-control custom-checkbox">
        <input type="checkbox" class="custom-control-input"
               id="sendExpiringSoonEmailInput" name="send_expiring_soon_email"
               [(ngModel)]="documentTemplate.send_expiring_soon_email"
               (ngModelChange)="unsavedChanges.emit()">
        <label class="custom-control-label checkbox-label"
               for="sendExpiringSoonEmailInput">
          Send an email before this document expires
        </label>
      </div>
      <div class="form-text text-danger">{{ documentTemplateErrors.send_expiring_soon_email }}</div>
      <small class="form-text text-muted">Customers are emailed between 9am and 10am in your organization's time zone. A customer will not be emailed if they have already signed a new document from this template.</small>
    </div>

    <div class="form-group indented-subsection" *ngIf="documentExpires() && documentTemplate.send_expiring_soon_email">
      <div class="form-group">
        <label for="expiringSoonEmailLeadDaysInput">Days before expiration</label>
        <input id="expiringSoonEmailLeadDaysInput" type="number" class="form-control"
               min="1" max="365" step="1"
               [(ngModel)]="documentTemplate.expiring_soon_email_lead_days"
               (ngModelChange)="unsavedChanges.emit()">
        <div class="form-text text-danger" *ngIf="leadDaysInvalid()">
          Enter a whole number from 1 to 365.
        </div>
        <div class="form-text text-danger">{{ documentTemplateErrors.expiring_soon_email_lead_days }}</div>
      </div>

      <div class="form-group">
        <label>Note to include in the email</label>
        <app-markdown-editor [id]="'expiringSoonEmailTextInput'"
                             [(content)]="documentTemplate.expiring_soon_email_text"
                             (contentChange)="unsavedChanges.emit()"
                             [shortEditor]="true"></app-markdown-editor>
        <small class="form-text text-muted">
          Optional. Shown in the email beneath the expiration date, for example how to renew at your location.
        </small>
        <div class="form-text text-danger">{{ documentTemplateErrors.expiring_soon_email_text }}</div>
      </div>

      <div class="form-group">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input"
                 id="expiringSoonEmailIncludeButtonInput" name="expiring_soon_email_include_button"
                 [(ngModel)]="documentTemplate.expiring_soon_email_include_button"
                 (ngModelChange)="unsavedChanges.emit()">
          <label class="custom-control-label checkbox-label"
                 for="expiringSoonEmailIncludeButtonInput">
            Include a button to complete the document again
          </label>
        </div>
        <small class="form-text text-muted" *ngIf="!documentTemplate.is_available_in_climber_app">
          This document is not available in the Climber App, so the button will be left out of the email.
        </small>
        <div class="form-text text-danger">{{ documentTemplateErrors.expiring_soon_email_include_button }}</div>
      </div>

      <div class="form-group" *ngIf="documentTemplate.expiring_soon_email_include_button">
        <label for="expiringSoonEmailButtonTextInput">Button text</label>
        <input id="expiringSoonEmailButtonTextInput" type="text" class="form-control"
               maxlength="64" placeholder="Complete a New Document"
               [(ngModel)]="documentTemplate.expiring_soon_email_button_text"
               (ngModelChange)="unsavedChanges.emit()">
        <small class="form-text text-muted">Leave blank to use the default.</small>
        <div class="form-text text-danger">{{ documentTemplateErrors.expiring_soon_email_button_text }}</div>
      </div>

      <div class="form-group">
        <button type="button" class="btn btn-outline-primary btn-sm"
                [disabled]="!documentTemplate.id || leadDaysInvalid()"
                (click)="openExpiringSoonEmailPreviewModal()">
          Preview Email
        </button>
        <small class="form-text text-muted" *ngIf="!documentTemplate.id">
          Save the document template to preview the email.
        </small>
      </div>
    </div>

    <div class="form-group" *ngIf="documentExpires()">
      <div class="custom-control custom-checkbox">
        <input type="checkbox" class="custom-control-input"
               id="sendExpiredEmailInput" name="send_expired_email"
               [(ngModel)]="documentTemplate.send_expired_email"
               (ngModelChange)="unsavedChanges.emit()">
        <label class="custom-control-label checkbox-label"
               for="sendExpiredEmailInput">
          Send an email when this document expires
        </label>
      </div>
      <div class="form-text text-danger">{{ documentTemplateErrors.send_expired_email }}</div>
      <small class="form-text text-muted">Customers are emailed between 9am and 10am in your organization's time zone on the day the document expires. Turning this on also emails customers whose document expired within the past week. A customer will not be emailed if they have already signed a new document from this template.</small>
    </div>

    <div class="form-group indented-subsection" *ngIf="documentExpires() && documentTemplate.send_expired_email">
      <div class="form-group">
        <label>Note to include in the email</label>
        <app-markdown-editor [id]="'expiredEmailTextInput'"
                             [(content)]="documentTemplate.expired_email_text"
                             (contentChange)="unsavedChanges.emit()"
                             [shortEditor]="true"></app-markdown-editor>
        <small class="form-text text-muted">
          Optional. Shown in the email beneath the expiration date, for example how to sign a new document at your location.
        </small>
        <div class="form-text text-danger">{{ documentTemplateErrors.expired_email_text }}</div>
      </div>

      <div class="form-group">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input"
                 id="expiredEmailIncludeButtonInput" name="expired_email_include_button"
                 [(ngModel)]="documentTemplate.expired_email_include_button"
                 (ngModelChange)="unsavedChanges.emit()">
          <label class="custom-control-label checkbox-label"
                 for="expiredEmailIncludeButtonInput">
            Include a button to complete the document again
          </label>
        </div>
        <small class="form-text text-muted" *ngIf="!documentTemplate.is_available_in_climber_app">
          This document is not available in the Climber App, so the button will be left out of the email.
        </small>
        <div class="form-text text-danger">{{ documentTemplateErrors.expired_email_include_button }}</div>
      </div>

      <div class="form-group" *ngIf="documentTemplate.expired_email_include_button">
        <label for="expiredEmailButtonTextInput">Button text</label>
        <input id="expiredEmailButtonTextInput" type="text" class="form-control"
               maxlength="64" placeholder="Complete a New Document"
               [(ngModel)]="documentTemplate.expired_email_button_text"
               (ngModelChange)="unsavedChanges.emit()">
        <small class="form-text text-muted">Leave blank to use the default.</small>
        <div class="form-text text-danger">{{ documentTemplateErrors.expired_email_button_text }}</div>
      </div>

      <div class="form-group">
        <button type="button" class="btn btn-outline-primary btn-sm"
                [disabled]="!documentTemplate.id"
                (click)="openExpiredEmailPreviewModal()">
          Preview Email
        </button>
        <small class="form-text text-muted" *ngIf="!documentTemplate.id">
          Save the document template to preview the email.
        </small>
      </div>
    </div>

    <div class="form-group" *ngIf="documentHasWaiverFunction()">
      <label for="can_be_used_for_barcode_check_in">Can this document be used for check-in via the Check-In Site (barcode scanner)?</label>
      <select id="can_be_used_for_barcode_check_in" class="custom-select"
              [(ngModel)]="documentTemplate.can_be_used_for_barcode_check_in"
              (ngModelChange)="unsavedChanges.emit()">
        <option [ngValue]="true">Yes</option>
        <option [ngValue]="false">No</option>
      </select>
      <small class="form-text text-muted">
        If set to "No", then this document only counts as an active waiver/AoR when the customer is checked in manually by staff via the Staff Site. This can be used to ensure that staff are able to perform manual checks as needed, such as checking that a supervisor is present for a supervised climber.
      </small>
      <div class="form-text text-danger">{{ documentTemplateErrors.can_be_used_for_barcode_check_in }}</div>
    </div>

    <div class="form-group" *ngIf="(documentTemplate.document_type === DocumentType.supervisorForm) && documentTemplate.is_available_to_supervisors_with_supervisees">
      <label for="countsAsWaiverForSuperviseesSelect">Does this document count as a Waiver/AoR for supervisees?</label>
      <select id="countsAsWaiverForSuperviseesSelect" class="custom-select"
              [(ngModel)]="documentTemplate.counts_as_waiver_for_supervisees"
              (ngModelChange)="unsavedChanges.emit()">
        <option [ngValue]="true">Yes</option>
        <option [ngValue]="false">No</option>
      </select>
      <div class="form-text text-danger">{{ documentTemplateErrors.counts_as_waiver_for_supervisees }}</div>
    </div>

    <div class="form-group" *ngIf="documentTemplate.document_type === DocumentType.waiver">
      <label>Who can sign up with this document?</label>
      <div class="form-check ml-3">
        <input class="form-check-input" type="checkbox" id="signUpAdultCheckbox"
               [(ngModel)]="documentTemplate.is_available_to_adult_participants"
               (ngModelChange)="unsavedChanges.emit()">
        <label class="form-check-label" for="signUpAdultCheckbox">
          Adult
        </label>
      </div>
      <div class="form-check ml-3">
        <input class="form-check-input" type="checkbox" id="signUpAdultWithMinorsCheckbox"
               [(ngModel)]="documentTemplate.is_available_to_adults_with_minors"
               (ngModelChange)="unsavedChanges.emit()">
        <label class="form-check-label" for="signUpAdultWithMinorsCheckbox">
          Adult with Minor(s)
        </label>
      </div>
      <div class="form-check ml-3">
        <input class="form-check-input" type="checkbox" id="signUpAdultNonpWithMinorsCheckbox"
               [(ngModel)]="documentTemplate.is_available_to_minors"
               (ngModelChange)="unsavedChanges.emit()">
        <label class="form-check-label" for="signUpAdultNonpWithMinorsCheckbox">
          Adult Non-Participant with Minor(s)
        </label>
      </div>
      <div class="form-check ml-3">
        <input class="form-check-input" type="checkbox" id="signUpAdultNonpWithUnsupMinorsCheckbox"
               [(ngModel)]="documentTemplate.is_available_to_unsupervised_minors"
               (ngModelChange)="unsavedChanges.emit()">
        <label class="form-check-label" for="signUpAdultNonpWithUnsupMinorsCheckbox">
          Adult Non-Participant with Unsupervised Minor(s)
        </label>
      </div>
      <div class="form-check ml-3">
        <input class="form-check-input" type="checkbox" id="signUpAdultWithSupAdult"
               [(ngModel)]="documentTemplate.is_available_to_adults_with_supervised_adults"
               (ngModelChange)="unsavedChanges.emit()">
        <label class="form-check-label" for="signUpAdultWithSupAdult">
          Adult with Supervised Adult
        </label>
      </div>
      <small class="form-text text-muted">
        This document will not count as a waiver for any customer who fills it out as a non-participant.
      </small>
    </div>

    <div class="form-group" *ngIf="documentTemplate.document_type === DocumentType.supervisorForm">
      <label>Who can complete this form?</label>
      <div class="form-check ml-3">
        <input class="form-check-input" type="checkbox" id="allowedSuperisorsAloneCheckbox"
               [(ngModel)]="documentTemplate.is_available_to_supervisors_alone"
               (ngModelChange)="unsavedChanges.emit()">
        <label class="form-check-label" for="allowedSuperisorsAloneCheckbox">
          Supervisors alone
        </label>
      </div>
      <div class="form-check ml-3">
        <input class="form-check-input" type="checkbox" id="allowedSuperisorsWithSuperviseesCheckbox"
               [(ngModel)]="documentTemplate.is_available_to_supervisors_with_supervisees"
               (ngModelChange)="unsavedChanges.emit()">
        <label class="form-check-label" for="allowedSuperisorsWithSuperviseesCheckbox">
          Supervisors with supervisees
        </label>
      </div>
    </div>

    <ng-container *ngIf="documentTemplate.document_type === DocumentType.waiver">
      <div class="form-group" *ngIf="documentTemplate.is_available_to_adult_participants || documentTemplate.is_available_to_adults_with_minors || documentTemplate.is_available_to_adults_with_supervised_adults">
        <label class="mb-1">Proficiencies added to <b>Adult</b> profile after completing document:</label>
        <label *ngIf="loadingProficiencies" class="form-text text-muted">Loading...</label>
        <label *ngIf="!loadingProficiencies && (proficiencyList.length === 0)" class="form-text text-muted">
          No proficiencies are configured
        </label>
        <div class="form-check ml-3" *ngFor="let proficiency of proficiencyList">
          <input class="form-check-input" type="checkbox" [id]="'adult-prof-' + proficiency.id.toString()"
                 [checked]="documentTemplate.granted_adult_proficiencies.includes(proficiency.id)"
                 (change)="toggleItemInList(proficiency.id, documentTemplate.granted_adult_proficiencies)">
          <label class="form-check-label" [for]="'adult-prof-' + proficiency.id.toString()">
            {{ proficiency.name }}
          </label>
        </div>
        <div class="form-text text-danger">{{ documentTemplateErrors.granted_adult_proficiencies }}</div>
      </div>

      <div class="form-group" *ngIf="documentTemplate.is_available_to_minors || documentTemplate.is_available_to_unsupervised_minors">
        <label class="mb-1">Proficiencies added to <b>Adult Non-Participant</b> profile after completing document:</label>
        <label *ngIf="loadingProficiencies" class="form-text text-muted">Loading...</label>
        <label *ngIf="!loadingProficiencies && (proficiencyList.length === 0)" class="form-text text-muted">
          No proficiencies are configured
        </label>
        <div class="form-check ml-3" *ngFor="let proficiency of proficiencyList">
          <input class="form-check-input" type="checkbox" [id]="'adult-non-prof-' + proficiency.id.toString()"
                 [checked]="documentTemplate.granted_adult_non_participant_proficiencies.includes(proficiency.id)"
                 (change)="toggleItemInList(proficiency.id, documentTemplate.granted_adult_non_participant_proficiencies)">
          <label class="form-check-label" [for]="'adult-non-prof-' + proficiency.id.toString()">
            {{ proficiency.name }}
          </label>
        </div>
        <div class="form-text text-danger">{{ documentTemplateErrors.granted_adult_non_participant_proficiencies }}</div>
      </div>

      <div class="form-group" *ngIf="documentTemplate.is_available_to_adults_with_minors || documentTemplate.is_available_to_minors">
        <label class="mb-1">Proficiencies added to <b>Minor</b> profile after completing document:</label>
        <label *ngIf="loadingProficiencies" class="form-text text-muted">Loading...</label>
        <label *ngIf="!loadingProficiencies && (proficiencyList.length === 0)" class="form-text text-muted">
          No proficiencies are configured
        </label>
        <div class="form-check ml-3" *ngFor="let proficiency of proficiencyList">
          <input class="form-check-input" type="checkbox" [id]="'minor-prof-' + proficiency.id.toString()"
                 [checked]="documentTemplate.granted_minor_proficiencies.includes(proficiency.id)"
                 (change)="toggleItemInList(proficiency.id, documentTemplate.granted_minor_proficiencies)">
          <label class="form-check-label" [for]="'minor-prof-' + proficiency.id.toString()">
            {{ proficiency.name }}
          </label>
        </div>
        <div class="form-text text-danger">{{ documentTemplateErrors.granted_minor_proficiencies }}</div>
      </div>

      <div class="form-group" *ngIf="documentTemplate.is_available_to_unsupervised_minors">
        <label class="mb-1">Proficiencies added to <b>Unsupervised Minor</b> profile after completing document:</label>
        <label *ngIf="loadingProficiencies" class="form-text text-muted">Loading...</label>
        <label *ngIf="!loadingProficiencies && (proficiencyList.length === 0)" class="form-text text-muted">
          No proficiencies are configured
        </label>
        <div class="form-check ml-3" *ngFor="let proficiency of proficiencyList">
          <input class="form-check-input" type="checkbox" [id]="'unsup-minor-prof-' + proficiency.id.toString()"
                 [checked]="documentTemplate.granted_unsupervised_minor_proficiencies.includes(proficiency.id)"
                 (change)="toggleItemInList(proficiency.id, documentTemplate.granted_unsupervised_minor_proficiencies)">
          <label class="form-check-label" [for]="'unsup-minor-prof-' + proficiency.id.toString()">
            {{ proficiency.name }}
          </label>
        </div>
        <div class="form-text text-danger">{{ documentTemplateErrors.granted_unsupervised_minor_proficiencies }}</div>
      </div>

      <div class="form-group" *ngIf="documentTemplate.is_available_to_adults_with_supervised_adults">
        <label class="mb-1">Proficiencies added to <b>Supervised Adult</b> profile after completing document:</label>
        <label *ngIf="loadingProficiencies" class="form-text text-muted">Loading...</label>
        <label *ngIf="!loadingProficiencies && (proficiencyList.length === 0)" class="form-text text-muted">
          No proficiencies are configured
        </label>
        <div class="form-check ml-3" *ngFor="let proficiency of proficiencyList">
          <input class="form-check-input" type="checkbox" [id]="'sup-adult-prof-' + proficiency.id.toString()"
                 [checked]="documentTemplate.granted_supervised_adult_proficiencies.includes(proficiency.id)"
                 (change)="toggleItemInList(proficiency.id, documentTemplate.granted_supervised_adult_proficiencies)">
          <label class="form-check-label" [for]="'sup-adult-prof-' + proficiency.id.toString()">
            {{ proficiency.name }}
          </label>
        </div>
        <div class="form-text text-danger">{{ documentTemplateErrors.granted_supervised_adult_proficiencies }}</div>
      </div>
    </ng-container><!-- Waiver proficiencies -->

    <ng-container *ngIf="documentTemplate.document_type === DocumentType.supervisorForm">
      <div class="form-group">
        <label class="mb-1">Proficiencies added to <b>Supervisor</b> profile after completing document:</label>
        <label *ngIf="loadingProficiencies" class="form-text text-muted">Loading...</label>
        <label *ngIf="!loadingProficiencies && (proficiencyList.length === 0)" class="form-text text-muted">
          No proficiencies are configured
        </label>
        <div class="form-check ml-3" *ngFor="let proficiency of proficiencyList">
          <input class="form-check-input" type="checkbox" [id]="'supervisor-prof-' + proficiency.id.toString()"
                 [checked]="documentTemplate.granted_supervisor_proficiencies.includes(proficiency.id)"
                 (change)="toggleItemInList(proficiency.id, documentTemplate.granted_supervisor_proficiencies)">
          <label class="form-check-label" [for]="'supervisor-prof-' + proficiency.id.toString()">
            {{ proficiency.name }}
          </label>
        </div>
        <div class="form-text text-danger">{{ documentTemplateErrors.granted_supervisor_proficiencies }}</div>
      </div>

      <div class="form-group" *ngIf="documentTemplate.is_available_to_supervisors_with_supervisees">
        <label class="mb-1">Proficiencies added to <b>Supervisee</b> profile after completing document:</label>
        <label *ngIf="loadingProficiencies" class="form-text text-muted">Loading...</label>
        <label *ngIf="!loadingProficiencies && (proficiencyList.length === 0)" class="form-text text-muted">
          No proficiencies are configured
        </label>
        <div class="form-check ml-3" *ngFor="let proficiency of proficiencyList">
          <input class="form-check-input" type="checkbox" [id]="'supervisee-prof-' + proficiency.id.toString()"
                 [checked]="documentTemplate.granted_supervisee_proficiencies.includes(proficiency.id)"
                 (change)="toggleItemInList(proficiency.id, documentTemplate.granted_supervisee_proficiencies)">
          <label class="form-check-label" [for]="'supervisee-prof-' + proficiency.id.toString()">
            {{ proficiency.name }}
          </label>
        </div>
        <div class="form-text text-danger">{{ documentTemplateErrors.granted_supervisee_proficiencies }}</div>
      </div>
    </ng-container><!-- Supervisor form proficiencies -->

    <ng-container *ngIf="documentTemplate.document_type === DocumentType.proficiency">
      <div class="form-group">
        <label class="mb-1">Proficiencies added to <b>Customer</b> profile after completing document:</label>
        <label *ngIf="loadingProficiencies" class="form-text text-muted">Loading...</label>
        <label *ngIf="!loadingProficiencies && (proficiencyList.length === 0)" class="form-text text-muted">
          No proficiencies are configured
        </label>
        <div class="form-check ml-3" *ngFor="let proficiency of proficiencyList">
          <input class="form-check-input" type="checkbox" [id]="'customer-prof-' + proficiency.id.toString()"
                 [checked]="documentTemplate.granted_climber_proficiencies.includes(proficiency.id)"
                 (change)="toggleItemInList(proficiency.id, documentTemplate.granted_climber_proficiencies)">
          <label class="form-check-label" [for]="'customer-prof-' + proficiency.id.toString()">
            {{ proficiency.name }}
          </label>
        </div>
        <div class="form-text text-danger">{{ documentTemplateErrors.granted_climber_proficiencies }}</div>
      </div>
    </ng-container><!-- Proficiency form proficiencies -->

    <div class="form-group" *ngIf="documentTemplate.document_type === DocumentType.waiver">
      <label for="adult_min_age">Adult Minimum Age (Optional)</label>
      <input id="adult_min_age" type="number" min="0" step="1"
             class="form-control" name="adult_min_age"
             [(ngModel)]="documentTemplate.adult_min_age"
             (ngModelChange)="unsavedChanges.emit()">
      <small class="form-text text-muted">
        This sets the minimum age allowed for customers in <b>adult</b> info sections. Leave this blank to use the default value of 18 years.
      </small>
      <div class="form-text text-danger">{{ documentTemplateErrors.adult_min_age }}</div>
    </div>
    <div class="form-group" *ngIf="documentTemplate.document_type === DocumentType.waiver">
      <label for="minor_max_age">Minor Maximum Age (Optional)</label>
      <input id="minor_max_age" type="number" min="1" step="1"
             class="form-control" name="minor_max_age"
             [(ngModel)]="documentTemplate.minor_max_age"
             (ngModelChange)="unsavedChanges.emit()">
      <small class="form-text text-muted">
        This sets the maximum age allowed for customers in <b>minor</b> info sections. Leave this blank to use the default value of 17 years.
      </small>
      <div class="form-text text-danger">{{ documentTemplateErrors.minor_max_age }}</div>
    </div>

    <div class="form-group" *ngIf="(documentTemplate.document_type === DocumentType.waiver) || (documentTemplate.document_type === DocumentType.supervisorForm)">
      <label for="maxSecondaryInput">How many secondary customers may be associated with this document?</label>
      <input id="maxSecondaryInput" type="number" min="1" max="10" step="1"
             class="form-control" name="max_secondary_customer_count"
             [(ngModel)]="documentTemplate.max_secondary_customer_count"
             (ngModelChange)="unsavedChanges.emit()">
      <small class="form-text text-muted">
        This determines the maximum number of
        <ng-container *ngIf="documentTemplate.document_type === DocumentType.waiver">
          minors or supervised adults
        </ng-container>
        <ng-container *ngIf="documentTemplate.document_type === DocumentType.supervisorForm">
          supervisees
        </ng-container>
        which may be selected when filling out a document. Must be between 1 and 10.
      </small>
      <div class="form-text text-danger">{{ documentTemplateErrors.max_secondary_customer_count }}</div>
    </div>

    <div class="form-group">
      <label>Document Welcome Text (Optional)</label>
      <app-markdown-editor [id]="'welcomeText'"
                           [(content)]="documentTemplate.welcome_text"
                           [shortEditor]="true"></app-markdown-editor>
      <small class="form-text text-muted">
        This text is shown to the customer before they begin filling out the document.
      </small>
      <div class="form-text text-danger">{{ documentTemplateErrors.welcome_text }}</div>
    </div>

    <div class="form-group">
      <label>Document Confirmation Text (Optional)</label>
      <app-markdown-editor [id]="'confirmationText'"
                           [(content)]="documentTemplate.confirmation_text"
                           [shortEditor]="true"></app-markdown-editor>
      <div class="form-text text-danger">{{ documentTemplateErrors.confirmation_text }}</div>
    </div>

    <h3 class="mt-3 mb-0">Quiz Question Policies</h3>
    <p class="mt-0 mb-2"><small>
      These fields only apply if this document contains quiz question elements.
    </small></p>

    <div class="form-group">
      <label>Incorrect Quiz Answer Error Message - Kiosk Mode (Optional)</label>
      <app-markdown-editor [id]="'quizErrorMessageKiosk'"
                           [(content)]="documentTemplate.quiz_error_message_kiosk"
                           [shortEditor]="true"></app-markdown-editor>
      <small class="form-text text-muted">
        This message will be shown when a customer attempts to submit a document page with an incorrect quiz answer in Kiosk Mode. If this is left blank, a generic message will be used.
      </small>
      <div class="form-text text-danger">{{ documentTemplateErrors.quiz_error_message_kiosk }}</div>
    </div>

    <div class="form-group">
      <label for="quizErrorAlertImmediatelyClimberAppSelect">
        Will the customer be alerted immediately when they answer a quiz question incorrectly in the Climber App?
      </label>
      <select id="quizErrorAlertImmediatelyClimberAppSelect" class="custom-select"
              [(ngModel)]="documentTemplate.quiz_error_alert_immediately_climber_app"
              (ngModelChange)="unsavedChanges.emit()">
        <option [ngValue]="true">Yes</option>
        <option [ngValue]="false">No</option>
      </select>
      <small class="form-text text-muted">
        If this is set to "No", then the customer will only be informed after they complete the document, at which point the document will be marked as invalid.
      </small>
      <div class="form-text text-danger">
        {{ documentTemplateErrors.quiz_error_alert_immediately_climber_app }}
      </div>
    </div>

    <div class="form-group" *ngIf="!documentTemplate.quiz_error_alert_immediately_climber_app">
      <label for="quizErrorCreateInboxItemClimberAppSelect">
        Will an inbox item be created when a customer completes a document with an incorrect quiz answer?
      </label>
      <select id="quizErrorCreateInboxItemClimberAppSelect" class="custom-select"
              [(ngModel)]="documentTemplate.quiz_error_create_inbox_item_climber_app"
              (ngModelChange)="unsavedChanges.emit()">
        <option [ngValue]="true">Yes</option>
        <option [ngValue]="false">No</option>
      </select>
      <div class="form-text text-danger">
        {{ documentTemplateErrors.quiz_error_create_inbox_item_climber_app }}
      </div>
    </div>

    <div class="form-group">
      <label>Incorrect Quiz Answer Error Message - Climber App (Optional)</label>
      <app-markdown-editor [id]="'quizErrorMessageClimberApp'"
                           [(content)]="documentTemplate.quiz_error_message_climber_app"
                           [shortEditor]="true"></app-markdown-editor>
      <small class="form-text text-muted">
        <ng-container *ngIf="documentTemplate.quiz_error_alert_immediately_climber_app">
          This message will be shown when a customer attempts to submit a document page with an incorrect quiz answer in the Climber App.
        </ng-container>
        <ng-container *ngIf="!documentTemplate.quiz_error_alert_immediately_climber_app">
          This message will be shown after a customer completes a document with an incorrect quiz answer in the Climber App, replacing the document confirmation text.
        </ng-container>

        If this is left blank, a generic message will be used.
      </small>
      <div class="form-text text-danger">{{ documentTemplateErrors.quiz_error_message_climber_app }}</div>
    </div>

  </div>
</div>
